import React from 'react';
import PropTypes from 'prop-types';
import MenuRounded from '@material-ui/icons/MenuRounded';
import Drawer from '@material-ui/core/Drawer';

import Component from '../../../Component';
import { withResizer, withTranslations } from '../../../../HoCs';
import styles from './styles';
import OYO from '../../../../resources/vectors/oyo';
import IconButton from '../../../Button/Icon';
import Account from '../Account';
import Help from '../Help';
import { blackMedium } from '../../../../resources/styles';
import { isEmptyString } from '../../../../utils';
import RevenuePopper from '../RevenuePopper';
import { earningPotentialEnabled } from '../../../../config/countryConfig';

class Header extends Component {

    state = {
        helpOpen: false,
    };
    styles = styles;

    toggleHelp = bool => () => this.setState({ helpOpen: bool });

    render = () => <>
        <div style={this.gs('container')}>
            <div style={this.gs('left')}>
                <IconButton style={this.gs('menu')} onClick={this.props.onMenuClick}><MenuRounded style={this.gs('menu_icon')} /></IconButton>
                <OYO style={this.gs('oyo')} width={58} height={20} />
                <div style={this.gs('left_divider')} />
                <div style={this.gs('owner_portal')}>{this.guc('owner_portal')}</div>
                {!isEmptyString(this.props.title) && <div style={this.gs('page_title')}>{this.props.title}</div>}
            </div>
            <div style={this.gs('right')}>
                <div style={this.gs('need_help')} onClick={this.toggleHelp(true)}>{this.guc('FAQs')}</div>
                
                {this.getWidth() > 600 && earningPotentialEnabled() && <RevenuePopper/>}
                
                <div style={this.gs('right_divider')} />
                <Account/>
            </div>
        </div>
        <Drawer BackdropProps={{ style: { backgroundColor: blackMedium.color } }}
            PaperProps={{ style: { backgroundColor: 'white', boxShadow: 'none' } }}
            open={this.state.helpOpen} onClose={this.toggleHelp(false)} anchor='right'>
            
            <Help style={{ width: this.getWidth() < 615 ? this.getWidth() : 615 }} />
        </Drawer>
    </>;

}

Header.propTypes = {
    title: PropTypes.string,
    onMenuClick: PropTypes.func.isRequired,
}

export default withResizer(withTranslations(Header));